import React from "react";
import Reveal from "../common/Reveal";
import { updatesMode, pinnedUpdate, changelog } from "../data/releaseNotes";

export default function ReleaseNotes() {
  const isLive = updatesMode === "live";

  return (
    <section id="updates" className="section">
      <div className="section-inner">
        <Reveal className="section-label-row tight">
          <span className="section-label mono">05 / RELEASE NOTES</span>
          <span className="section-line" />
          {isLive ? (
            <span className="live-indicator mono">
              <span className="pulse-dot" />
              LIVE
            </span>
          ) : (
            <span className="mono" style={{ fontSize: 11, letterSpacing: "0.12em", color: "var(--fg-faint)" }}>
              SOON
            </span>
          )}
        </Reveal>

        {!isLive && (
          <Reveal className="status-card">
            <span className="status-pill mono">
              <span className="pulse-dot" />
              COMING SOON
            </span>
            <h2 className="status-headline">Release notes are on the way</h2>
            <p className="status-copy">
              This feed is wired up and ready. Once updates start shipping
              across my projects, they'll land here — pinned like a
              notification worth checking.
            </p>
            <p className="status-note mono">
              {"// no updates published yet — check back soon"}
            </p>
          </Reveal>
        )}

        {isLive && (
          <>
            <Reveal as="h2" className="section-headline">
              What's new, shipped.
            </Reveal>
            <Reveal as="p" className="section-sub">
              A running changelog of updates across my projects — the newest
              change is pinned like an update worth reading.
            </Reveal>

            <Reveal className="pinned-card">
              <div className="pinned-bar" />
              <div className="pinned-meta-row">
                <span className="pulse-dot" />
                <span className="pinned-new mono">NEW</span>
                <span className="pinned-label mono">PINNED UPDATE</span>
                <span style={{ flex: 1 }} />
                <span className="pinned-time mono">{pinnedUpdate.timestamp}</span>
              </div>
              <div className="pinned-version-row">
                <span className="version-pill mono">{pinnedUpdate.version}</span>
                <span className="project-tag-mono">{pinnedUpdate.project}</span>
              </div>
              <h3 className="pinned-title">{pinnedUpdate.title}</h3>
              <p className="pinned-body">{pinnedUpdate.body}</p>
              <div className="pinned-links mono">
                <a className="lnk project-link-live" href={pinnedUpdate.live.href} target="_blank" rel="noreferrer">
                  {pinnedUpdate.live.label}
                </a>
                <a className="lnk project-link-code" href={pinnedUpdate.notes.href} target="_blank" rel="noreferrer">
                  {pinnedUpdate.notes.label}
                </a>
              </div>
            </Reveal>

            <div className="changelog-list stagger">
              {changelog.map((entry) => (
                <Reveal as="div" className="changelog-row" key={entry.title}>
                  <div className="changelog-left">
                    <span className="changelog-date mono">{entry.date}</span>
                    <span className="changelog-version mono">{entry.version}</span>
                  </div>
                  <div className="changelog-right">
                    <div className="changelog-title-row">
                      <h3 className="changelog-title">{entry.title}</h3>
                      <span className="changelog-project mono">{entry.project}</span>
                    </div>
                    <p className="changelog-note">{entry.note}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
